export default __webpack_public_path__ + "static/media/Tiziano Terzani.c045b9e5.jpg";